import { Dialog, DialogActions, DialogContent, DialogContentProps, DialogProps, IconButton, Typography, withStyles, Tooltip } from '@material-ui/core';
import MuiDialogTitle, { DialogTitleProps } from '@material-ui/core/DialogTitle';
import React from 'react';
import { connect } from 'react-redux';
import { IModalProps } from '../../store/modules/ModalsReducer';
import { IReducer } from '../../store/Reducer';
import { getElementID, getMergedClassNames } from './../../utils/HTMLUtils';
// import TooltipCaller from '../TooltipManager/TooltipCaller';
// import {HelpButton} from '../HelpButton';
import styles from './GenericModal.scss';
import { CloseIcon } from 'components/Icons';

const rootClassName = styles.rootClassName;

const DialogTitle = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(),
    top: '50%',
    transform: 'translateY(-50%)',
    color: theme.palette.grey[500],
  },
  closeIcon: {
    width: '20px',
    height: '20px',
    color: styles.primarySicredi
  }
}))((props: any) => {
  const { children, classes, className, onClose, closeText, closeButtonId } = props;
  return (
    <MuiDialogTitle disableTypography className={ getMergedClassNames([
      classes.root,
      className
    ]) }>
      <Typography variant="h6">{ children }</Typography>
        { typeof onClose === 'function' ? (
          <Tooltip title={ closeText } arrow>
            <IconButton id={ closeButtonId } aria-label="Close" className={classes.closeButton} onClick={onClose}>
              <CloseIcon className={ classes.closeIcon } />
            </IconButton>
          </Tooltip>
        ) : '' }
    </MuiDialogTitle>
  );
});

export interface IGenericModalProps {
  id?: string,
  open?: boolean,
  titleHint?: string,
  onClose?: Function,
  DialogProps?: DialogProps,
  DialogTitleProps?: DialogTitleProps,
  DialogContentProps?: DialogContentProps,
  footerContent?: React.ElementType | React.ReactNode,
  onSubmit?: Function,
  maxWidth?: string,
}

export interface IGenericModal extends IModalProps {
  genericProps?: IGenericModalProps,
  disableBackdropClick?: boolean,
  disableEscapeKeyDown?: boolean
}

declare global {
  interface Window {
    getComputedStyle: (elt: Element, pseudoElt?: string | null | undefined) => CSSStyleDeclaration
  }
}

class GenericModal extends React.Component<IGenericModal, any> {

  constructor(props: IGenericModal) {
    super(props);
    this.state = {
      open: true,
      modalId: props.genericProps && props.genericProps.id ? props.genericProps.id : null,
      contentRef: React.createRef(),
      needScroll: false,
      scrollIsStart: false,
      scrollIsEnd: false,
    };
  }

  handleOpen = (open: boolean) => {
    this.setState({
      ...this.state,
      open: open,
      innerWidth: window.innerWidth
    });
  }

  updateDimensions = () => {
    let newState: any = {
      innerWidth: window.innerWidth,
    };
    // if (this.state.contentRef.current) {
    //   const elementDefaultView = this.state.contentRef.current.ownerDocument.defaultView;
    //   const contentContainerComputedStyle = elementDefaultView.getComputedStyle(this.state.contentRef.current);
    //   const contentComputedStyle = elementDefaultView.getComputedStyle(this.state.contentRef.current.childNodes[0]);
    //   const containerHeight = parseInt(contentContainerComputedStyle.height) - parseInt(contentContainerComputedStyle.paddingTop) - parseInt(contentContainerComputedStyle.paddingBottom);
    //   newState.needScroll = parseInt(contentComputedStyle.height) > containerHeight ? true : false;
    //   newState.scrollIsStart = parseInt(this.state.contentRef.current.scrollTop) === 0 ? true : false;
    //   newState.scrollIsEnd = (parseInt(this.state.contentRef.current.offsetHeight) + parseInt(this.state.contentRef.current.scrollTop)) === parseInt(this.state.contentRef.current.scrollHeight) ? true : false;
    // }
    this.setState(newState);
  }

  onEntered = () => {
    this.updateDimensions();
  }
  
  UNSAFE_componentWillMount() {
    this.updateDimensions();
  }
  
  UNSAFE_componentDidMount() {
    window.addEventListener("resize", this.updateDimensions);
    this.updateDimensions();
  }

  UNSAFE_componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  getDialogProps() {
    return {
      open: true,
      fullWidth: true,
      maxWidth: this.props.genericProps ? this.props.genericProps.maxWidth : 'xl',
      fullScreen: this.state.innerWidth < 534,
      'aria-labelledby': 'max-width-dialog-title',
      ...this.props.genericProps && this.props.genericProps.DialogProps ? this.props.genericProps.DialogProps : {},
      disableBackdropClick: typeof this.props.disableBackdropClick === 'boolean' ? this.props.disableBackdropClick : true,
      disableEscapeKeyDown: typeof this.props.disableEscapeKeyDown === 'boolean' ? this.props.disableEscapeKeyDown : true,
      className: getMergedClassNames([
        rootClassName,
        this.props.genericProps && typeof this.props.genericProps.onSubmit === 'function' ? rootClassName + '-with-form' : '',
        this.props.genericProps && this.props.genericProps.DialogProps && this.props.genericProps.DialogProps.className ? this.props.genericProps.DialogProps.className : '',
        this.state.needScroll ? rootClassName + '-need-scroll' : '',
        this.state.scrollIsStart ? rootClassName + '-scroll-is-start' : '',
        this.state.scrollIsEnd ? rootClassName + '-scroll-is-end' : '',
      ]),
      onEntered: this.onEntered,
      onClose: () => {
        if (this.props.genericProps && typeof this.props.genericProps.onClose === 'function') {
          this.props.genericProps.onClose();
        }
        this.handleOpen(false);
      }
    };
  }

  getHint = () => {
    // if (typeof this.props.titleHint === 'string') {
    //   return <HelpButton
    //     text={ this.props.titleHint }
    //     className={ rootClassName + '-header-hint-button' } />
    // }
    return null;
  }

  getForm = (children: any): any => {
    let formProps: any = {};
    if (this.props.genericProps && typeof this.props.genericProps.onSubmit === 'function') {
      formProps.onSubmit = typeof this.props.genericProps.onSubmit === 'function' ? this.props.genericProps.onSubmit : null;
      return (
        <form { ...formProps }>
          { children }
        </form>
      )
    }
    return children;
  }

  render() {
    let dialogTitleClassNames = [rootClassName + '-title'];
    if (this.props.genericProps && this.props.genericProps.DialogTitleProps && this.props.genericProps.DialogTitleProps.className) {
      dialogTitleClassNames.push(this.props.genericProps.DialogTitleProps.className);
    }
    const allDialogTitleProps: any = {
      ...this.props.genericProps && this.props.genericProps.DialogTitleProps ? this.props.genericProps.DialogTitleProps : {},
      closeButtonId: this.state.modalId ? getElementID(this.state.modalId, 'close') : null,
      className: dialogTitleClassNames.join(' '),
    }
    const dialogContentProps = {
      ...this.props.genericProps && this.props.genericProps.DialogContentProps ? this.props.genericProps.DialogContentProps : {},
      className: getMergedClassNames([
        rootClassName + '-content',
        this.props.genericProps && this.props.genericProps.footerContent ? rootClassName + '-with-actions' : '',
        this.props.genericProps && this.props.genericProps.DialogContentProps && this.props.genericProps.DialogContentProps.className ? this.props.genericProps.DialogContentProps.className : ''
      ]),
      onScroll: this.updateDimensions,
      ref: this.state.contentRef
    };
    const dialogActionsProps = {
      className: getMergedClassNames([
        rootClassName + '-actions'
      ])
    };
    const dialogProps: any = this.getDialogProps();
    return (
      <Dialog { ...dialogProps } >
        { this.getForm((
          <>
            <DialogTitle { ...allDialogTitleProps } onClose={ this.props.genericProps && this.props.genericProps.onClose ? this.props.genericProps.onClose : null } closeText={ 'Fechar' }>
              { this.props.title }
              { this.getHint() }
            </DialogTitle>
            <DialogContent { ...dialogContentProps }>
              { this.props.content }
            </DialogContent>
            {
              this.props.genericProps && this.props.genericProps.footerContent ? (
                <DialogActions { ...dialogActionsProps }>
                  { this.props.genericProps.footerContent }
                </DialogActions>
              ) : null
            }
          </>
        )) }
      </Dialog>
    );
  }
}

const mapStateToProps = (state: IReducer) => ({
  //languageValues: state.languages.languageValues,
});

export default connect(mapStateToProps)(GenericModal);